import { QqMessageProcessorBase } from "./qq-message-processor.base";
import { QqActionType } from "../qq-action.type";
import { QqStateType } from "../qq-state.type";
import { OptionProcessorService } from "../../services/option-processor.service";
import { QqBundleService } from "../../services/qq-bundle.service";

export class SliderProcessor extends QqMessageProcessorBase {
  process(action: QqActionType, state: QqStateType): QqStateType {
    if (!action.data.qq.optionsRange) return state;

    state.ctrlPos[action.data.qq.key] = action.data.position ?? 0;
    const currentValue = action.data.position ?? 0;

    const qqBundleService = new QqBundleService(state.qqBundle);
    const selectedOption = qqBundleService.getSliderRangeByValue(
      currentValue,
      action.data.qq
    );

    if (!selectedOption) return state;
    state.currentOptions[action.data.qq.key] = JSON.stringify(
      selectedOption.range
    );
    if (state.currentValues[action.data.qq.key])
      delete state.currentValues[action.data.qq.key];

    const optionRes = selectedOption.res;
    const optionsProcessor = new OptionProcessorService(
      state.qqBundle,
      state.ctrlBundle,
      state.currentOptions,
      state.currentValues,
      state.ctrlPos
    );

    optionsProcessor.processOption(action.data.qq, optionRes);
    optionsProcessor.ensureBundledCtrlsVisibility(
      action.data.qq.key,
      JSON.stringify(selectedOption.range),
      state.ctrlBundle
    );

    return { ...state };
  }
}
